module.exports = __webpack_public_path__ + "img/qualityControl.12f3c47.webp";